import React from 'react';
import { useEffect } from 'react';
import type { FC, MouseEvent } from 'react';

import { QrCode } from '../../assets/qrCode';
import { MAX_URL } from '../../data/config';
import styles from './QrModal.module.scss';
import { IconClose } from '../../assets/icons/icons';

interface QrModalProps {
    open: boolean;
    onClose: () => void;
}

export const QrModal: FC<QrModalProps> = ({ open, onClose }) => {
    useEffect(() => {
        if (!open) return;

        const handleKeyDown = (event: KeyboardEvent): void => {
            if (event.key === 'Escape') onClose();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [open, onClose]);

    if (!open) return null;

    const handleBackdropClick = (event: MouseEvent<HTMLDivElement>): void => {
        if (event.target === event.currentTarget) onClose();
    };

    return (
        <div
            className={styles.overlay}
            role="dialog"
            aria-modal="true"
            aria-label="QR-код MAX"
            onClick={handleBackdropClick}
        >
            <div className={styles.card}>
                <button type="button" className={styles.close} onClick={onClose} aria-label="Закрыть">
                    <IconClose />
                </button>

                <div className={styles.eyebrow}>Мессенджер MAX</div>

                <h3 className={styles.title}>Откройте MAX</h3>

                <p className={styles.text}>
                    Отсканируйте QR-код камерой смартфона, чтобы перейти в мессенджер.
                </p>

                <QrCode className={styles.image} role="img" aria-label="Увеличенный QR-код для перехода в MAX" />

                <a className={styles.link} href={MAX_URL} target="_blank" rel="noopener noreferrer">
                    Перейти в MAX ↗
                </a>
            </div>
        </div>
    );
};